import { render, staticRenderFns } from "./GestionInicial.vue?vue&type=template&id=7f8a9a1f&"
import script from "./GestionInicial.vue?vue&type=script&lang=js&"
export * from "./GestionInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports